import { render, staticRenderFns } from "./builder-card.vue?vue&type=template&id=19c71c0c&scoped=true&"
import script from "./builder-card.vue?vue&type=script&lang=js&"
export * from "./builder-card.vue?vue&type=script&lang=js&"
import style0 from "./builder-card.vue?vue&type=style&index=0&id=19c71c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c71c0c",
  null
  
)

export default component.exports